<button (click)="buttonClick.emit()" [class.light-background]="lightBackground()">
  <oph-icon [name]="(iconFolder() || 'color-icons/') + iconName()" [size]="40" class="task-icon"></oph-icon>
  <img src="assets/img/icons/chevron-down-brown.svg" />
</button>
